import { jwtDecode } from 'jwt-decode';

let accessToken = null;
let refreshTimeout = null;
let tokenExpiryCallback = null;

export const setAccessToken = (token) => {
  accessToken = token;
   window.dispatchEvent(new Event("authChanged"));
  if (token && tokenExpiryCallback) {
    try {
      const decoded = jwtDecode(token);
      const expiresIn = decoded.exp * 1000 - Date.now();
      const refreshTime = expiresIn - 60000;
      
      if (refreshTimeout) {
        clearTimeout(refreshTimeout);
      }
      
      if (refreshTime > 0 && tokenExpiryCallback) {
        refreshTimeout = setTimeout(() => {
          tokenExpiryCallback();
        }, refreshTime);
      }
    } catch (error) {
      console.error('Failed to decode token:', error);
    }
  }
};

export const getAccessToken = () => {
  return accessToken;
};

export const clearAccessToken = () => {
  accessToken = null;
  if (refreshTimeout) {
    clearTimeout(refreshTimeout);
    refreshTimeout = null;
  }
   window.dispatchEvent(new Event("authChanged"));
};

export const setTokenExpiryCallback = (callback) => {
  tokenExpiryCallback = callback;
};

export const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export default {
  setAccessToken,
  getAccessToken,
  clearAccessToken,
  setTokenExpiryCallback,
  isTokenExpired
};